import { render, staticRenderFns } from "./ChangelogList.vue?vue&type=template&id=4dfc83be&scoped=true&"
import script from "./ChangelogList.vue?vue&type=script&lang=js&"
export * from "./ChangelogList.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogList.vue?vue&type=style&index=0&id=4dfc83be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfc83be",
  null
  
)

export default component.exports